
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Axios from "Source/axiosPool";
import { showToast } from "Source/globalFunction";

@connect(store => {
    return {
        project: store.project
    };
})

class DeactivateAccount extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onDeactivate"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onDeactivate() {
        const { project, dispatch } = this.props;
        const selected = project.Selected;
        const status = {
            isActive: 0
        };

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        Axios.put(`api/project/status/${ selected.id }`, status)
            .then( response => {
                if( response ) {
                    dispatch({ type: "SET_PROJECT_INACTIVE", project: selected.id });

                    if( selected.typeId === 1 ) {
                        dispatch({ type: "SET_PROJECT_TYPE", projectType: "company" });
                    } else {
                        dispatch({ type: "SET_PROJECT_TYPE", projectType: "project" });
                    }

                    showToast( "success", "Account has been deactivated" );

                    window.location.replace("/account#/projects?inactive=" + selected.id);
                }
                dispatch({ type: "SET_PROJECT_REFETCH", boolean: true });
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
            });
    }

    render() {
        return (
            <div class="modal fade delete-modal bg-overlay" id="deactivateAccountModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-sldred text-semi-bold mb0">Deactivate account?</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt20 pb20">
                            <p class="m0 text-black">Do you wish to proceed ?</p>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btn-cancel text-black ml0" data-dismiss="modal">Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class="btn btn-danger btn-delete" onClick={ this.onDeactivate }>Deactivate</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeactivateAccount;
